var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlockicon = function SvgUnlockicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.51 2.54c-.16.2-.24.3-.3.34-.15.1-.22.1-.39.07-.08-.02-.23-.11-.54-.3A2.5 2.5 0 0 0 5.5 4.8v2.5h3.68l-.13 1.5H4v-4a4 4 0 0 1 6.65-2.97c.07.11.1.3.05.43a.99.99 0 0 1-.19.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.1 7.55C3 7.76 3 8.04 3 8.6v4.8c0 .56 0 .84.1 1.05a1 1 0 0 0 .45.44c.21.11.49.11 1.05.11h6.8c.56 0 .84 0 1.05-.1a1 1 0 0 0 .44-.45c.11-.21.11-.49.11-1.05V8.6c0-.56 0-.84-.1-1.05a1 1 0 0 0-.45-.44C12.24 7 11.96 7 11.4 7H4.6c-.56 0-.84 0-1.05.1a1 1 0 0 0-.44.45ZM8 9.5a.75.75 0 0 0-.75.75v1a.75.75 0 0 0 1.5 0v-1A.75.75 0 0 0 8 9.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgUnlockicon;